import { put } from 'redux-saga/effects';
import SchedulesActions from '../redux/SchedulesRedux';
import i18n from '../i18n';

export function* getSchedules(api, { customerId, pageParams }) {
  try {
    const getSchedulesResponse = yield api.getSchedules(customerId, pageParams);
    console.log('getSchedulesResponse:', getSchedulesResponse);
    if (getSchedulesResponse.ok) {
      yield put(
        SchedulesActions.getSchedulesRequestSuccess(
          getSchedulesResponse.data.content,
          getSchedulesResponse.data.totalElements
        )
      );
    } else {
      api.checkAuth(getSchedulesResponse);
      const error =
        typeof getSchedulesResponse.problem !== 'undefined'
          ? getSchedulesResponse.problem
          : typeof getSchedulesResponse.data.error !== 'undefined'
          ? i18n.t(getSchedulesResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(SchedulesActions.getSchedulesRequestFailure(error));
    }
  } catch (error) {
    console.log('error in Schedules saga', error);
    yield put(SchedulesActions.getSchedulesRequestFailure(error));
  }
}

export function* createSchedule(api, { scheduleInfos, customerId, pageParams }) {
  try {
    const createScheduleResponse = yield api.createSchedule(scheduleInfos);
    console.log('createScheduleResponse:', createScheduleResponse);
    const getScheduleResponse = yield api.getSchedules(customerId, pageParams);
    console.log('getScheduleResponse:', getScheduleResponse);
    const successMessage = i18n.t('successMessage.createSchedule');
    if (createScheduleResponse.ok && getScheduleResponse.ok) {
      yield put(
        SchedulesActions.createScheduleRequestSuccess(
          createScheduleResponse.data,
          getScheduleResponse.data.content,
          getScheduleResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(createScheduleResponse);
      api.checkAuth(getScheduleResponse);
      const error =
        typeof createScheduleResponse.problem !== 'undefined'
          ? createScheduleResponse.problem
          : typeof createScheduleResponse.data.error !== 'undefined'
          ? i18n.t(createScheduleResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(SchedulesActions.createScheduleRequestFailure(error));
    }
  } catch (error) {
    console.log('error in Schedule saga', error);
    yield put(SchedulesActions.createScheduleRequestFailure(error));
  }
}

export function* editSchedule(api, { scheduleInfos, customerId, pageParams }) {
  try {
    const editScheduleResponse = yield api.editSchedule(scheduleInfos);
    console.log('editScheduleResponse:', editScheduleResponse);
    const getScheduleResponse = yield api.getSchedules(customerId, pageParams);
    console.log('getScheduleResponse:', getScheduleResponse);
    const successMessage = i18n.t('successMessage.editSchedule');
    if (editScheduleResponse.ok && getScheduleResponse.ok) {
      yield put(
        SchedulesActions.editScheduleRequestSuccess(
          getScheduleResponse.data.content,
          getScheduleResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(editScheduleResponse);
      api.checkAuth(getScheduleResponse);
      const error =
        typeof editScheduleResponse.problem !== 'undefined'
          ? editScheduleResponse.problem
          : typeof editScheduleResponse.data.error !== 'undefined'
          ? i18n.t(editScheduleResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(SchedulesActions.editScheduleRequestFailure(error));
    }
  } catch (error) {
    console.log('error in Schedule saga', error);
    yield put(SchedulesActions.editScheduleRequestFailure(error));
  }
}

export function* deleteSchedule(api, { scheduleNameId, customerId, pageParams }) {
  try {
    const deleteScheduleResponse = yield api.deleteSchedule(scheduleNameId);
    console.log('deleteScheduleResponse:', deleteScheduleResponse);
    const getScheduleResponse = yield api.getSchedules(customerId, pageParams);
    console.log('getScheduleResponse:', getScheduleResponse);
    const successMessage = i18n.t('successMessage.deleteSchedule');
    if (deleteScheduleResponse.ok && getScheduleResponse.ok) {
      yield put(
        SchedulesActions.deleteScheduleRequestSuccess(
          getScheduleResponse.data.content,
          getScheduleResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(deleteScheduleResponse);
      api.checkAuth(getScheduleResponse);
      const error =
        typeof deleteScheduleResponse.problem !== 'undefined'
          ? deleteScheduleResponse.problem
          : typeof deleteScheduleResponse.data.error !== 'undefined'
          ? i18n.t(deleteScheduleResponse.data.error)
          : i18n.t('unexpectedError');
      yield put(SchedulesActions.deleteScheduleRequestFailure(error));
    }
  } catch (error) {
    console.log('error in Schedule saga', error);
    yield put(SchedulesActions.deleteScheduleRequestFailure(error));
  }
}
